import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

const CancelSuccessDialog = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h6">Cancelled</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ textAlign: "center", py: 3 }}>
        Action cancelled successfully.
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
        <button className="btn" onClick={onClose}>
          OK
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelSuccessDialog;
